export function getTrendDirection(
  trendValue: number,
): "rising" | "sinking" | "right" {
  const numericValue = Number(trendValue);
  if (numericValue > 0) return "rising";
  if (numericValue < 0) return "sinking";
  return "right";
}
